export default function Nd1FlowBreakdown({ children }) {
  return <div className="nd1-steps">{children}</div>;
}
